import { ShieldTick } from "@untitledui/icons";
import { TextArea } from "@/components/base/textarea/textarea";
import type { CustomRiskEditRequestForm } from "./RequestCustomRiskEditModal";

const START_FLAGGING_PLACEHOLDER = `e.g. Posts that list a calorie count noticeably lower than the actual product should be flagged.

1. https://
2. https://
3. https://`;

type Props = {
  form: CustomRiskEditRequestForm;
  onChange: (patch: Partial<CustomRiskEditRequestForm>) => void;
  errors: Record<string, string>;
};

export function StartFlaggingStep({ form, onChange, errors }: Props) {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex gap-8">
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <div className="flex items-start gap-1.5">
            <ShieldTick className="size-5 shrink-0 text-quaternary" />
            <p className="text-sm font-medium text-secondary">What should we start flagging?</p>
          </div>
          <ul className="list-disc pl-5 text-xs text-quaternary">
            <li>Describe what's slipping through that should be caught.</li>
            <li>Add links to example videos that aren't flagged today but should be.</li>
            <li>Aim for 3–5 example links if you can.</li>
          </ul>
        </div>
        <div className="w-[395px] shrink-0">
          <TextArea
            aria-label="What should we start flagging?"
            isRequired
            placeholder={START_FLAGGING_PLACEHOLDER}
            value={form.startFlagging}
            onChange={(v) => onChange({ startFlagging: v })}
            isInvalid={!!errors.startFlagging}
            rows={10}
          />
          {errors.startFlagging && <p className="mt-1.5 text-sm text-error-primary">{errors.startFlagging}</p>}
        </div>
      </div>

      <div className="flex flex-col gap-1 rounded-xl bg-warning-primary p-4">
        <p className="text-sm font-medium text-secondary">What happens after you submit</p>
        <p className="text-xs text-secondary">
          Your request goes straight to our AI team to action. Training the model takes time, so please allow up to a
          5-day turnaround. Someone may reach out if they need more detail.
        </p>
      </div>
    </div>
  );
}
